module.exports = __webpack_public_path__ + "static/media/glass-whiskey-rocks.e5a2c633.svg";